export default "__VITE_ASSET__0861c290__"